/** @format */

import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import CardBody from '../../../components/Card/CardBody';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import moment, { Moment } from 'moment';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';
import GridContainer from '../../../components/Grid/GridContainer';
import { ReactComponent as Cancel } from '../../../assets/themes/OPL/img/icons/Cancel.svg';
import Datetime from 'react-datetime';
import { DateHelperTs } from '../../../helpers/DateHelperTs';

export type InvoiceAcceptDialogProps = {
    openView: boolean;
    fullWidth: boolean;
    title?: string;
    displayMessage?: string;
    closeCallback: () => void;
    saveCallback: (params: any) => void;
    firstLoad: () => void;
    showMainLoader: (show: boolean) => void;
};

const _ = require('underscore');

export const InvoicePaidDialog = (props: InvoiceAcceptDialogProps): React.ReactElement => {
    const [date, setDate] = useState<string>();

    useEffect(() => {
        if (!date) {
            const time = moment(DateHelperTs.getCurrentDateSimple('YYYY-MM-DD'));
            setDate(time.format('YYYY-MM-DD'));
        }
    }, [date, setDate]);

    return (
        <Dialog
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            keepMounted
            open={props.openView}
            fullWidth={props.fullWidth}
            onClose={props.closeCallback}
            maxWidth="lg"
            style={{ height: '100vh' }}
        >
            <DialogTitle>
                <GridContainer justifyContent={'space-between'}>
                    <h4>
                        {props.title === null && ''}
                        {typeof props.title === 'string' ? <I18n trans={props.title} /> : props.title}
                    </h4>
                    <Button onClick={props.closeCallback} color="primary">
                        <Cancel width={24} height={24} />
                    </Button>
                </GridContainer>
            </DialogTitle>
            <DialogContent>
                <Card>
                    {props.displayMessage !== null && props.displayMessage !== '' && <CardHeader trans={props.displayMessage} />}
                    <CardBody>
                        <Datetime
                            locale="pl"
                            viewMode="days"
                            defaultValue={moment(DateHelperTs.getCurrentDateSimple('YYYY-MM-DD'))}
                            dateFormat="YYYY-MM-DD"
                            timeFormat={false}
                            onChange={(moment: Moment | string): void => {
                                if (typeof moment !== 'string') {
                                    setDate(moment.format('YYYY-MM-DD'));
                                }
                            }}
                            inputProps={{
                                id: 'acceptDate',
                                placeholder: 'YYYY-MM-DD',
                            }}
                        />
                        <div style={{ minHeight: '300px' }}>&nbsp;</div>
                    </CardBody>
                </Card>
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={props.saveCallback} callbackParam={{ date }} label="general:common.save" />
            </DialogActions>
        </Dialog>
    );
};

export default withStyles(oplAppStyle)(InvoicePaidDialog);
